<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title primary-title>
            <h3>{{ strings.changePassword }}</h3>
          </v-card-title>
          <v-form
            v-if="!loading"
            ref="form"
            v-model="valid"
            lazy-validation
            class="change-password"
          >
            <v-text-field
              v-model="oldPassword"
              label="Old Password"
              :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showOldPassword ? 'text' : 'password'"
              name="input-10-1"
              autocomplete="current-password"
              @click:append="showOldPassword = !showOldPassword"
            />
            <v-text-field
              v-model="newPassword"
              label="New Password"
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="passwordRules"
              :type="showNewPassword ? 'text' : 'password'"
              name="input-10-1"
              @click:append="showNewPassword = !showNewPassword"
            />
            <v-text-field
              v-model="checkPassword"
              label="Retype New Password"
              :append-icon="showCheckPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="checkPasswordRules"
              :type="showCheckPassword ? 'text' : 'password'"
              name="input-10-1"
              @click:append="showCheckPassword = !showCheckPassword"
            />
            <v-btn
              color="primary"
              @click="onSetPassword"
            >
             {{ strings.newPassword }}
            </v-btn>
          </v-form>
          <v-layout v-if="loading">
            <v-flex>
              <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
              />
            </v-flex>
          </v-layout>
          <v-layout
            v-if="
              editPasswordResponse != null && editPasswordResponse != undefined
            "
          >
            <v-flex
              grow
              @click="onEditPasswordResponseClick"
            >
              <v-alert
                :value="editPasswordResponse"
                type="success"
              >
                <v-layout
                  align-space-around
                  justify-space-around
                  row
                  fill-height
                >
                  <v-flex grow>
                    <h4 class="success-message">
                      {{ successMessage }}
                    </h4>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      small
                      fab
                      dark
                      color="rgba(0,0,0,.3)"
                      class="text-xs-right"
                      @click="onSuccessMessageOK"
                    >
                      {{ strings.ok }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-alert>
              <v-alert
                :value="!editPasswordResponse"
                type="error"
              >
                {{ failMessage }}
              </v-alert>
            </v-flex>
          </v-layout>
          <v-layout v-if="error">
            <v-flex>
              <v-alert
                :value="true"
                color="error"
                icon="mdi-alert"
              >
                {{ error }}
              </v-alert>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      oldPassword: "",
      showOldPassword: false,
      newPassword: "",
      showNewPassword: false,
      checkPassword: "",
      showCheckPassword: false,
      passwordRules: [
        v => !!v || "Password is required.",
        v => v.length >= 8 || "Min 8 characters"
      ],
      checkPasswordRules: [
        v => v === this.newPassword || "Passwords must match."
      ],
      successMessage: "Password changed succesfully",
      failMessage:
        "Could not change your password. please make sure the details given are correct",
      errorMessage: "Oops... somthing went wrong please try again later"
    };
  },
  computed: {
    ...mapGetters("login", {
      loading: "loading",
      error: "error",
      editPasswordResponse: "editPasswordResponse"
    }),
    ...mapGetters("page", ["strings"]),
  },
  methods: {
    onSetPassword() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("login/changePassword", {
          vm: this,
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        });
      }
    },
    onErrorMessageClick() {
      this.$store.commit("login/clearError");
    },
    onEditPasswordResponseClick() {
      this.$store.commit("login/clearEditPasswordResponse");
    },
    onSuccessMessageOK() {
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.v-btn {
  color: var(--v-text-base) !important;
}

.v-form.change-password {
  padding: 1em 2em 1em 2em;
}
</style>
